import React from 'react';
import PropTypes from 'prop-types';
import { FormControlLabel, Switch } from '@mui/material';

import { t } from 'i18n';

const FirstDayOrderFilter = ({ value, onChange }) => {
  const selected = value === 'today';

  return (
    <FormControlLabel
      control={
        <Switch
          checked={selected}
          onChange={(event) => onChange(event.target.checked ? 'today' : '')}
          size="small"
        />
      }
      label={t('First-day Orders Only')}
      sx={{marginLeft: 0, marginRight: 0}}
    />
  );
};

FirstDayOrderFilter.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default FirstDayOrderFilter;
